import React from 'react'
import { downloadPDF } from 'utils/misc'
import { Button } from 'components/UIElements'

import accountSetupFirstStep from '../assets/account-setup1.png'
import accountSetupSecondStep from '../assets/account-setup2.png'
import accountSetupThirdStep from '../assets/account-setup3.png'
import accountSetupFourthStep from '../assets/account-setup4.png'
import 'styles/d3/accountSetupTooltip.scss'

const ACCOUNT_SETUP_STEPS = [
  {
    id: '1',
    imageSrc: accountSetupFirstStep,
    label: 'Schedule a call or a meeting with the participant to complete account setup.',
  },
  {
    id: '2',
    imageSrc: accountSetupSecondStep,
    label: 'At the time of the appointment or when the participant is ready to login, generate temporary password. ',
  },
  {
    id: '3',
    imageSrc: accountSetupThirdStep,
    label: 'Communicate the auto-generated username and password to the participant.',
  },
  {
    id: '4',
    imageSrc: accountSetupFourthStep,
    label:
      'Account setup is successful when the participant logs in for the first time. The temporary password will expire after 24hours.',
  },
]

const AccountSetupTooltip = ({ url, fileName }) => {
  return (
    <div className='tooltip-content'>
      <h4 className='heading'>Complete Account Setup</h4>
      <p className='description'>
        This study does not collect any participant contact information. An admin will need to communicate with the
        participant outside of of Datacubed Health platform with registration information as follows:
      </p>
      <div className='steps-list'>
        {ACCOUNT_SETUP_STEPS.map(step => (
          <div key={step.id} className='steps-list-item'>
            <p className='item-number'>{step.id}</p>
            <img src={step.imageSrc} />
            <p className='item-label'>{step.label}</p>
          </div>
        ))}
      </div>
      <div className='bottom-text flexed end-justified'>
        Questions? Download
        <Button className='account-setup-u' noStyling inline onClick={() => downloadPDF(url, fileName)}>
          <u>this guide.</u>
        </Button>
      </div>
    </div>
  )
}

AccountSetupTooltip.propTypes = {}

export default AccountSetupTooltip
